import type { OrganizationTier } from '@/types/BillingOrganization'

export type NavigationId =
  | 'ask-ai'
  | 'award-search'
  | 'budget-search'
  | 'catalog'
  | 'companies'
  | 'excerpts'
  | 'files'
  | 'federal-contracts'
  | 'federal-grants'
  | 'dibbs-contracts'
  | 'sbirs'
  | 'sled-contracts'
  | 'home'
  | 'library'
  | 'monitors'
  | 'inbox'
  | 'people'
  | 'profile'
  | 'pursuits'
  | 'recipient-search'
  | 'protest-search'
  | 'forecast-search'
  | 'vehicle-search'
  | 'naics-search'
  | 'psc-search'
  | 'saved-searches'
  | 'schedules'
  | 'search'
  | 'settings'
  | 'templates'
  | 'word-templates'
  | 'tasks'
  | 'documents'

export const NAVIGATION_ID_TO_TITLE: Record<NavigationId, string> = {
  'ask-ai': 'Ask AI',
  'award-search': 'Federal Award AI',
  'budget-search': 'Federal Budget',
  catalog: 'Catalog',
  companies: 'Companies',
  excerpts: 'Excerpts',
  files: 'Files',
  'federal-contracts': 'Federal Contracts',
  'federal-grants': 'Federal Grants',
  'dibbs-contracts': 'DIBBS Contracts',
  sbirs: 'SBIR/STTRs',
  'sled-contracts': 'State & Local Contracts',
  home: 'Home',
  library: 'Library',
  monitors: 'Monitors',
  inbox: 'Inbox',
  people: 'People',
  profile: 'Profile',
  pursuits: 'Pursuits',
  'recipient-search': 'Recipients',
  'protest-search': 'Protests',
  'forecast-search': 'Forecasts',
  'vehicle-search': 'Vehicles',
  'naics-search': 'NAICS',
  'psc-search': 'PSC',
  'saved-searches': 'Saved Searches',
  schedules: 'Schedules',
  search: 'Search',
  settings: 'Settings',
  templates: 'Templates',
  'word-templates': 'Word Templates',
  tasks: 'My Tasks',
  documents: 'My Proposal Documents',
}

export type NavigationOption = {
  id: NavigationId
  name: string
  href: string
  current: boolean
  isOrganizationFeature: boolean
  requiresOrganizationRead?: boolean
  minOrganizationTier: OrganizationTier
  isTrialEligible: boolean
  /** When set, bypasses tier/trial checks entirely — true grants access, false denies it. */
  accessOverride?: boolean
  /** Tooltip shown instead of the upsell when the option is disabled. */
  disabledTooltip?: string
  icon?: any
  activeIcon?: any
  children?: Array<NavigationOption>
  childrenTitle?: string
  viewAllChildrenHref?: string
  match: (pathname: string) => boolean
}
